/* BLUND — Cart drawer engine (dependency-free, /cart.js based) */
(function () {
  "use strict";

  var root = document.querySelector("[data-vita-cart]");
  if (!root) return;
  var body = root.querySelector("[data-vita-cart-body]");
  var foot = root.querySelector("[data-vita-cart-foot]");
  var subtotalEl = root.querySelector("[data-vita-cart-subtotal]");
  var countLabel = root.querySelector("[data-vita-cart-count-label]");
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || "EUR";
  var locale = document.documentElement.lang || "en";

  function money(cents) {
    try { return new Intl.NumberFormat(locale, { style: "currency", currency: currency }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2) + " " + currency; }
  }

  /* ---- open / close ---- */
  function open() { root.hidden = false; requestAnimationFrame(function () { root.classList.add("is-open"); }); document.body.style.overflow = "hidden"; }
  function close() { root.classList.remove("is-open"); document.body.style.overflow = ""; setTimeout(function () { root.hidden = true; }, 320); }

  document.addEventListener("click", function (e) {
    var opener = e.target.closest("[data-vita-cart-open]");
    if (opener) { e.preventDefault(); open(); refresh(); return; }
    if (e.target.closest("[data-vita-cart-close]")) { close(); }
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !root.hidden) close(); });

  /* ---- render ---- */
  function setCounts(count) {
    document.querySelectorAll("[data-vita-cart-count]").forEach(function (el) { el.textContent = count; });
    if (countLabel) countLabel.textContent = "(" + count + ")";
  }

  function renderLines(cart) {
    if (!cart.items.length) {
      body.innerHTML = '<div class="vita-cart__empty"><p>Your cart is empty.</p></div>';
      if (foot) foot.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;
    var html = cart.items.map(function (item, i) {
      var variant = (item.variant_title && item.variant_title.indexOf("Default") === -1)
        ? '<div class="vita-cart-line__variant">' + item.variant_title + "</div>" : "";
      var imgUrl = item.image ? (item.image + (item.image.indexOf("?") > -1 ? "&" : "?") + "width=160") : "";
      var img = item.image
        ? '<img class="vita-cart-line__img" src="' + imgUrl + '" width="64" height="64" loading="lazy" alt="">'
        : '<span class="vita-cart-line__img"></span>';
      return '<div class="vita-cart-line" data-key="' + item.key + '">' +
        '<a href="' + item.url + '" tabindex="-1">' + img + "</a>" +
        "<div>" +
          '<a href="' + item.url + '" class="vita-cart-line__title">' + item.product_title + "</a>" +
          variant +
          '<div class="vita-cart-line__controls">' +
            '<button type="button" data-vita-line-minus aria-label="Decrease">−</button>' +
            '<span class="vita-cart-line__qty">' + item.quantity + "</span>" +
            '<button type="button" data-vita-line-plus aria-label="Increase">+</button>' +
          "</div>" +
          '<button type="button" class="vita-cart-line__remove" data-vita-line-remove>Remove</button>' +
        "</div>" +
        '<div class="vita-cart-line__price">' + money(item.final_line_price) + "</div>" +
      "</div>";
    }).join("");
    body.innerHTML = html;
  }

  function updateUI(cart) {
    setCounts(cart.item_count);
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
    renderLines(cart);
  }

  /* ---- fetch helpers ---- */
  function refresh() {
    return fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(updateUI)
      .catch(function () {});
  }

  function changeLine(key, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(updateUI);
  }

  /* line +/- and remove (event delegation) */
  body.addEventListener("click", function (e) {
    var line = e.target.closest("[data-key]");
    if (!line) return;
    var key = line.getAttribute("data-key");
    var qtyEl = line.querySelector(".vita-cart-line__qty");
    var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
    if (e.target.closest("[data-vita-line-plus]")) changeLine(key, qty + 1);
    else if (e.target.closest("[data-vita-line-minus]")) changeLine(key, Math.max(0, qty - 1));
    else if (e.target.closest("[data-vita-line-remove]")) changeLine(key, 0);
  });

  /* ---- intercept product forms for AJAX add ---- */
  document.querySelectorAll('form[action$="/cart/add"], form[id^="vita-product-form"]').forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = form.querySelector('[name="add"]');
      var original = btn ? btn.querySelector("[data-vita-atc-text]") || btn : null;
      var prevText = original ? original.textContent : "";
      if (original) original.textContent = "Añadiendo…";
      if (btn) btn.disabled = true;

      fetch("/cart/add.js", { method: "POST", headers: { "Accept": "application/json" }, body: new FormData(form) })
        .then(function (r) { return r.json(); })
        .then(function () { return refresh(); })
        .then(function () { open(); })
        .catch(function () {})
        .finally(function () {
          if (original) original.textContent = prevText;
          if (btn) btn.disabled = false;
        });
    });
  });

  // initial sync
  refresh();
})();
